import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from './configureStore';

export interface ToastMessage {
    id: number;
    title: string;
    message: string;
    type: 'success' | 'error' | 'info' | 'warning';
}

export interface ToastState {
    toasts: ToastMessage[];
}
const initialState: ToastState = {
    toasts: [],
};

export const toastSlice = createSlice({
    name: 'toastSlice',
    initialState,
    reducers: {
        addToast: (state, action: PayloadAction<Omit<ToastMessage, 'id'>>) => {
            state.toasts.push({ id: Date.now() + state.toasts.length, ...action.payload });
        },
        removeToast: (state, action: PayloadAction<number>) => {
            state.toasts = state.toasts.filter((toast) => toast.id !== action.payload);
        },
    },
});

export const selectState = (state: RootState) => state.toastSlice;
export const selectToasts = createSelector(selectState, (state) => state.toasts);

export const { addToast, removeToast } = toastSlice.actions;
